import { useContext, useState } from "react";
import { State, StateContext } from "../state";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { T } from "../i18n";
import dayjs from "dayjs";
import moment from "moment";
import { getMinBookableDate } from "../utils/utils.";


export const DateStartInput = ({ variant, forceOpen, onStartSetted }: any) => {

    const { start, setStart } = useContext(StateContext) as State;
    const [open, setOpen] = useState(false)

    const onChange = (v: any) => {
      setOpen(false); 
      if(!start && v) {
        setStart(v.startOf('day'))
        if(onStartSetted) {
          onStartSetted(v)
        }
      } else {
        setStart(v.startOf('day'))
      }
    }

    let openOnClick = !open && !forceOpen
    if (start) {
      openOnClick = !open
    }

    // Prima data prenotabile: si può prenotare fino a 10 ore prima della fascia
    // oraria del tour (il filtro fine per singola fascia è nel selettore fascia).
    const minDate = getMinBookableDate(dayjs())
    // max tra 18 mesi
    const maxDate = dayjs(moment().add(540, 'days').format('YYYY/MM/DD')).startOf('day')
  
    return (
      <div>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
          <span onClick={() => openOnClick && setOpen(true)}>
            <DatePicker
              value={start}
              disablePast
              minDate={minDate}
              maxDate={maxDate}
              onChange={(v) => onChange(v)}
              onClose={() => setOpen(false)}
              open={open || (!start && forceOpen)}
              className={`fullwidth datepicker ${variant}`}
              label={!start && !open ? variant ? T('date_1'): T('date_0'): undefined}
            />
          </span>
        </LocalizationProvider>
      </div>
    );
  }
  